import React from 'react';
import { Callout, Only, P, Steps, Sub, UI } from '../ui';

export const Updates: React.FC = () => (
  <>
    <Sub>자동으로 알려줍니다 <Only env="desktop" /></Sub>
    <P>
      앱이 새 버전을 스스로 확인합니다. 실행 직후 한 번, 이후에는 30분마다 확인하며 새 버전이 있으면 화면 오른쪽
      위에 안내 카드가 나타납니다.
    </P>
    <Steps>
      <>
        <UI>새 버전 v1.1.128이(가) 있습니다.</UI> 카드가 나타납니다.
      </>
      <>
        <UI>지금 설치</UI>를 누르면 내려받기와 설치가 자동으로 진행됩니다.
      </>
      <>설치가 끝나면 앱이 스스로 다시 시작됩니다. 로그인 상태와 대화 내용은 그대로 유지됩니다.</>
    </Steps>
    <P>
      지금 바쁘다면 <UI>×</UI>로 닫아도 됩니다. 30분 뒤에 다시 안내합니다.
    </P>

    <Sub>직접 확인하기</Sub>
    <P>
      <UI>설정</UI> → <UI>앱 업데이트</UI> → <UI>업데이트 확인</UI> 버튼을 누릅니다. 최신 상태라면{' '}
      <UI>최신 버전입니다</UI>, 새 버전이 있으면 버튼이 <UI>v1.1.128 설치</UI>로 바뀝니다.
    </P>

    <Callout tone="tip" title="업데이트는 되도록 바로 설치하세요">
      <p>
        업데이트에는 오류 수정과 보안 개선이 포함됩니다. 설치에 걸리는 시간은 보통 1분 이내이고 대화 내용은 서버에
        보관되므로 사라지지 않습니다.
      </p>
      <p>설치가 실패하면 빨간 안내가 잠시 표시됩니다. 여러 번 실패한다면 관리자에게 문의해 주세요.</p>
    </Callout>

    <Sub>웹 버전 <Only env="web" /></Sub>
    <P>
      웹 버전은 설치가 필요 없습니다. 새 버전이 배포되면 화면 위쪽에 파란 띠로 <UI>새 버전이 있습니다.</UI> 안내가
      나타나며, <UI>새로고침</UI>을 누르면 최신 화면으로 바뀝니다.
    </P>

    <Sub>직접 새로고침하기 <Only env="web" /></Sub>
    <P>
      안내 띠가 없을 때도 언제든 새로고침할 수 있습니다. 홈·대화방·온라인 화면에서 목록 맨 위를 아래로 당기면
      새로고침되고, <UI>설정</UI> 탭의 <UI>새로고침</UI>을 눌러도 됩니다. 홈 화면에 설치한 앱에는 주소창이 없어
      이 두 가지가 새로고침 방법입니다.
    </P>
  </>
);
